import PropTypes from "prop-types"
import MuiButton from "@mui/material/Button";

export function Button({
  children,
  loading = false,
  success = false,
  startIcon,
  endIcon,
  variant = "contained",
  color = "secondary",
  size = "medium",
  fullWidth = false,
  onClick,
  ...rest
}) {
  return (
    <MuiButton
      disabled={loading || success}
      variant={variant}
      color={color}
      size={size}
      fullWidth={fullWidth}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      {...rest}
    >
      {children}
    </MuiButton>
  );
}

Button.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  endIcon: PropTypes.any,
  fullWidth: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.any,
  size: PropTypes.string,
  startIcon: PropTypes.any,
  success: PropTypes.bool,
  variant: PropTypes.string
}
